import axios from "axios";

const marinaFormBaseUrl = process.env.VUE_APP_API_URL_MARINA_FORM;
const httpClient = axios.create({
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 120000
});

export default {
  healthCheck() {
    return httpClient.get(marinaFormBaseUrl);
  },
  postMarinaInfo(payload) {
    return httpClient.post(`${marinaFormBaseUrl}create`, payload, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
};
